import { Helmet } from 'react-helmet-async';
import { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import {
  Grid,
  Box,
  CardHeader,
  Button,
  Container,
  FormControl,
  Select,
  MenuItem,
  Skeleton,
  Typography,
} from '@mui/material';
import { zonedTimeToUtc, format } from 'date-fns-tz';
import DatePicker from 'react-datepicker';

// hooks
import axiosInstance from '../hooks/axiosInstance';

// sections
import {
  AppWebsiteVisits,
  AppWidgetSummaryLiveData,
  AppCurrentSubject,
  PhotoCamera,
} from '../sections/@dashboard/app';
import AppDayNightSettings from '../sections/@dashboard/app/AppDayNightSettings';

// Import komponen LightSpectrumControl untuk pengaturan spektrum
import SpectrometerGraph from '../sections/@dashboard/app/SpectrometerGraph';


// ----------------------------------------------------------------------


export default function DashboardAppPage() {
  const StyledContent = styled('div')(({ theme }) => ({
    maxWidth: 480,
    margin: 'auto',
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: theme.spacing(12, 0),
  }));

  const [isLoading, setIsloading] = useState(true);
  const [sseData, setSSEData] = useState({});
  const [zero, setZero] = useState(false);
  const today = new Date();
  const startDate = new Date(today);
  const endDate = new Date(today);
  startDate.setMonth(startDate.getMonth() - 1);
  const [selectedDate, setSelectedDate] = useState(today);
  const [selectedStartDate, setSelectedStartDate] = useState(startDate);
  const [selectedEndDate, setSelectedEndDate] = useState(endDate);
  const [graphData, setGraphData] = useState([]);
  // Tambahkan properti co2 dan lightSpectrum pada state chartData
  const [chartData, setChartData] = useState({
    temperature: [],
    intensity: [],
    humidity: [],
    cpu_temp: [],
    co2: [],           // data CO2
    lightSpectrum: [], // data spektrum cahaya
    time: [],
  });
  const [deviceData, setDeviceData] = useState([]);
  const [IDDevice, setIDDevice] = useState(localStorage.getItem('device_id'));
  const [NameDevice, setNameDevice] = useState(localStorage.getItem('device_name'));
  const [cameraTop, setcameraTop] = useState([]);
  const [cameraBot, setcameraBot] = useState([]);
  const [cameraTopRight, setcameraTopRight] = useState([]);
  const [cameraBotRight, setcameraBotRight] = useState([]);
  const [cameraUser, setcameraUser] = useState([]);
  const [showMessage, setShowMessage] = useState(true);
  const jwtToken = localStorage.getItem('jwtToken');
  const level = localStorage.getItem('level');
  const [averageData, setAverageData] = useState([]); // Initializing with null or an initial value
  const [spectrometerRef, setSpectrometerRef] = useState([]); // Spectrometer Image
  const [spectrometerPlot, setSpectrometerPlot] = useState([]); // Spectrometer Plot

  const fetchAverageData = async (chamberId, date) => {
    try {
      console.log('Fetching average data for chamberId:', chamberId, 'and date:', date);
      const response = await axiosInstance.get(`/condition/average/${chamberId}?date=${date}`);
      console.log('Response from API:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching data from the new API endpoint:', error);
      throw error;
    }
  };

  useEffect(() => {
    const userID = localStorage.getItem('token');
    if (level === '1') {
      axiosInstance.get(`/device/list/${userID}`).then((response) => {
        if (response.data.data.length === 0) {
          setIsloading(true);
          setZero(true);
        } else {
          setZero(false);
          setDeviceData(response.data.data);
        }
        if (localStorage.getItem('device_id') === null && localStorage.getItem('device_name') === null) {
          setIDDevice(response.data.data[0].id);
          setNameDevice(response.data.data[0].code_device);
          localStorage.setItem('device_id', response.data.data[0].id);
          localStorage.setItem('device_name', response.data.data[0].code_device);
        }
        console.log("cek response data 1:", response.data.data);
      });
    } else if (level === '2') {
      axiosInstance.get(`/device/find`).then((response) => {
        if (response.data.data.length === 0) {
          setIsloading(true);
          setZero(true);
        } else {
          setZero(false);
          setDeviceData(response.data.data);
        }
        if (localStorage.getItem('device_id') === null && localStorage.getItem('device_name') === null) {
          setIDDevice(response.data.data[0].id);
          setNameDevice(response.data.data[0].code_device);
          localStorage.setItem('device_id', response.data.data[0].id);
          localStorage.setItem('device_name', response.data.data[0].code_device);
        }
        console.log("cek response data 2:", response.data.data);
      });
    }
  }, [level]);

  useEffect(() => {
    const fetchAverageDataFromApi = async () => {
      try {
        const timeZone = 'Asia/Jakarta';
        const formattedDate = format(zonedTimeToUtc(selectedDate, timeZone), 'yyyy-MM-dd');

        const response = await fetchAverageData(IDDevice, formattedDate);
        console.log('Response from API:', response);

        if (response && response.status === 'success' && response.data && response.data.length > 0) {
          // Update the state with the fetched data
          setAverageData(response.data);
          console.log('Average Data:', response.data);
        } else {
          console.log('No valid data received from the API');
        }
      } catch (error) {
        console.error('Error fetching average data:', error);
      }
    };

    fetchAverageDataFromApi();
  }, [IDDevice, selectedDate]);

  // ADMINSSE untuk live data
  useEffect(() => {
    if (IDDevice && jwtToken) {
      const eventSource = new EventSource(
        `https://demo.smartfarm.id/condition/events/${IDDevice}?jwt_token=${jwtToken}`
      );
      eventSource.onmessage = (event) => {
        const data = JSON.parse(event.data);
        setSSEData(data);
      };
      return () => {
        eventSource.close();
      };
    }
    return () => {};
  }, [IDDevice, jwtToken]);

  useEffect(() => {
    if (IDDevice) {
      axiosInstance.get(`/file/listtop/${IDDevice}`).then((response) => {
        setcameraTop(response.data.data);
      });
      axiosInstance.get(`/file/listbottom/${IDDevice}`).then((response) => {
        setcameraBot(response.data.data);
      });
      axiosInstance.get(`/file/listtopright/${IDDevice}`).then((response) => {
        setcameraTopRight(response.data.data);
      });
      axiosInstance.get(`/file/listbottomright/${IDDevice}`).then((response) => {
        setcameraBotRight(response.data.data);
      });
      axiosInstance.get(`/file/listuser/${IDDevice}`).then((response) => {
        setcameraUser(response.data.data);
      });
    }
  }, [IDDevice]);

  useEffect(() => {
    if (IDDevice) {
      // Fetch spectrometer data
      axiosInstance.get(`/file/listspectrometer/plot/${IDDevice}`)
        .then((response) => {
          setSpectrometerPlot(response.data.data);
        })
        .catch((error) => {
          console.error('Error fetching spectrometer plot:', error);
        });
      axiosInstance.get(`/file/listspectrometer/reference/${IDDevice}`)
        .then((response) => {
          setSpectrometerRef(response.data.data);
        })
        .catch((error) => {
          console.error('Error fetching spectrometer reference:', error);
        });
    }
  }, [IDDevice]);

  useEffect(() => {
    setIsloading(true);
    const fetchData = () => {
      if (IDDevice !== null) {
        axiosInstance
          .get(`/condition/info/${IDDevice}?date=${format(zonedTimeToUtc(selectedDate, timeZone), 'yyyy-MM-dd')}`)
          .then((response) => {
            if (response.data.data.length === 0) {
              setIsloading(false);
              setGraphData([]);
            } else {
              setGraphData(response.data.data);
            }
          });
      }
    };
    fetchData();
  }, [IDDevice, selectedDate]);

  useEffect(() => {
    const temperatureData = [];
    const intensityData = [];
    const humidityData = [];
    const cpuTempData = [];
    const co2Data = [];           // Array untuk data CO2
    const lightSpectrumData = []; // Array untuk data spektrum cahaya
    const timeData = [];

    if (graphData.length !== 0 && chartData.length === 0) {
      setIsloading(true);
    } else if (graphData.length !== 0 && chartData.length !== 0) {
      setIsloading(false);
    }

    const hourDataCounts = {}; // Keep track of data counts for each hour

    graphData.forEach((item) => {
      temperatureData.push(parseFloat(item.temperature));
      intensityData.push(item.intensity);
      humidityData.push(parseFloat(item.humidity));
      cpuTempData.push(parseFloat(item.gateway_temp));
      // Ambil data CO2 dan spektrum cahaya, pastikan tipe data sesuai
      co2Data.push(parseFloat(item.co2level));
      lightSpectrumData.push(parseFloat(item.lightSpectrum));

      // Assuming item.time is in the format "hour:minute"
      const timeParts = item.time.split(':');
      const hours = parseInt(timeParts[0], 10);

      if (hourDataCounts[hours] === undefined) {
        hourDataCounts[hours] = 1;
      } else {
        hourDataCounts[hours] += 1;
      }

      if (hourDataCounts[hours] === 1) {
        timeData.push(`${hours}:00`);
      } else if (hourDataCounts[hours] === 15) {
        timeData.push(`${hours}:30`);
      } else {
        timeData.push('');
      }
    });

    setChartData({
      temperature: temperatureData,
      intensity: intensityData,
      humidity: humidityData,
      cpu_temp: cpuTempData,
      co2: co2Data,                 // Set data CO2
      lightSpectrum: lightSpectrumData, // Set data spektrum cahaya
      time: timeData,
    });
    // eslint-disable-next-line
  }, [graphData]);

  const handleDateChange = (dateString) => {
    const dateObject = new Date(dateString);
    setSelectedDate(dateObject);
  };

  const downloadExcel = () => {
    const timeZone = 'Asia/Jakarta';
    const formattedStartDate = format(zonedTimeToUtc(selectedStartDate, timeZone), 'yyyy-MM-dd');
    const formattedEndDate = format(zonedTimeToUtc(selectedEndDate, timeZone), 'yyyy-MM-dd');
    const axiosConfig = {
      method: 'get',
      url: `/condition/download/${IDDevice}?startDate=${formattedStartDate}&endDate=${formattedEndDate}`,
      responseType: 'blob',
    };

    axiosInstance(axiosConfig)
      .then((response) => {
        const filename = `Data Chamber ${NameDevice} on ${formattedStartDate} until ${formattedEndDate} .xlsx`;
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = URL.createObjectURL(blob);
        const downloadLink = document.createElement('a');
        downloadLink.href = url;
        downloadLink.download = filename;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      })
      .catch((error) => {
        console.error('Error downloading Excel file:', error);
      });
  };

  const handleStartDateChange = (date) => {
    setSelectedStartDate(date);
  };

  const handleEndDateChange = (date) => {
    setSelectedEndDate(date);
  };

  const timeZone = 'Asia/Jakarta';
  const formattedDate = format(zonedTimeToUtc(selectedDate, timeZone), 'yyyy-MM-dd');
  const formattedDateForDisplay = new Date(formattedDate).toLocaleString('en-us', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowMessage(false);
    }, 10010);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    console.log('SSE Data:', {
      humHigh: sseData.humHigh,
      humHighType: typeof sseData.humHigh,
      humHighNumber: Number(sseData.humHigh),
      humLow: sseData.humLow,
      humLowType: typeof sseData.humLow,
      humLowNumber: Number(sseData.humLow)
    });
  }, [sseData]);

  return (
    <>
      <Helmet>
        <title> Dashboard | Plant Growth Chamber </title>
      </Helmet>
      {isLoading && !zero ? (
        <Skeleton
          variant="rounded"
          height={550}
          sx={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', mx: 3, my: 2 }}
        />
      ) : zero ? (
        <Container>
          <StyledContent sx={{ textAlign: 'center', alignItems: 'center' }}>
            <Typography variant="h3" paragraph>
              Sorry
            </Typography>
            <Typography sx={{ color: 'text.secondary' }}>Sorry, you didn’t have any access to the device.</Typography>
            <Box
              component="img"
              src="/assets/illustrations/chamber_depan.png"
              sx={{ height: 260, mx: 'auto', my: { xs: 5, sm: 10 } }}
            />
            <Button to="/dashboard/access" size="large" variant="contained" component={RouterLink}>
              Go Request Access
            </Button>
          </StyledContent>
        </Container>
      ) : (
        <Container maxWidth="xl">
          <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
            <Select
              id="demo-select-small"
              onChange={(e) => {
                const deviceId = e.target.value;
                const selectedDevice = deviceData.find((device) => device.id === deviceId);
                setIDDevice(e.target.value);
                localStorage.setItem('device_id', e.target.value);
                localStorage.setItem('device_name', selectedDevice.code_device);
                setNameDevice(selectedDevice.code_device);
                window.location.reload();
              }}
              sx={{
                boxShadow: 'none',
                '.MuiOutlinedInput-notchedOutline': { border: 0 },
                '&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': { border: 0 },
                '&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': { border: 0 },
              }}
              value={NameDevice}
              renderValue={() => <Typography variant="h4">{NameDevice}</Typography>}
              inputProps={{ 'aria-label': 'Without label' }}
            >
              {deviceData.map((device) => (
                <MenuItem key={device.id} value={device.id}>
                  {device.code_device}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {sseData.mode === 'manual' && (
            <Box
              mb={2}
              sx={{
                textAlign: 'center',
                backgroundColor: '#fdecea',
                padding: '10px',
                borderRadius: '10px',
              }}
            >
              <Typography variant="body1" sx={{ display: 'inline-block', verticalAlign: 'middle' }}>
                <span role="img" aria-label="warning" style={{ fontSize: '16px', marginRight: '5px' }}>
                  ⚠️
                </span>
                This device is being controlled in Manual mode via onsite display. You can check the User Camera to see onsite user.
              </Typography>
            </Box>
          )}

          {Number(sseData.tempHigh) === 1 && (
            <Box
              mb={2}
              sx={{
                textAlign: 'center',
                backgroundColor: '#fdecea',
                padding: '10px',
                borderRadius: '10px',
              }}
            >
              <Typography variant="body1" sx={{ display: 'inline-block', verticalAlign: 'middle' }}>
                <span role="img" aria-label="warning" style={{ fontSize: '16px', marginRight: '5px' }}>
                  ⚠️
                </span>
                Abnormal Temperature increase is detected! Please check the chamber
              </Typography>
            </Box>
          )}

          {Number(sseData.tempLow) === 1 && (
            <Box
              mb={2}
              sx={{
                textAlign: 'center',
                backgroundColor: '#fdecea',
                padding: '10px',
                borderRadius: '10px',
              }}
            >
              <Typography variant="body1" sx={{ display: 'inline-block', verticalAlign: 'middle' }}>
                <span role="img" aria-label="warning" style={{ fontSize: '16px', marginRight: '5px' }}>
                  ⚠️
                </span>
                Abnormal Temperature decrease is detected! Please check the chamber
              </Typography>
            </Box>
          )}

          {Number(sseData.co2High) === 1 && (
            <Box
              mb={2}
              sx={{
                textAlign: 'center',
                backgroundColor: '#fdecea',
                padding: '10px',
                borderRadius: '10px',
              }}
            >
              <Typography variant="body1" sx={{ display: 'inline-block', verticalAlign: 'middle' }}>
                <span role="img" aria-label="warning" style={{ fontSize: '16px', marginRight: '5px' }}>
                  ⚠️
                </span>
                Abnormal CO2 Level increase is detected! Please check the chamber and the scrubber
              </Typography>
            </Box>
          )}

          {Number(sseData.co2level) > 1100 && (
            <Box
              mb={2}
              sx={{
                textAlign: 'center',
                backgroundColor: '#fdecea',
                padding: '10px',
                borderRadius: '10px',
              }}
            >
              <Typography variant="body1" sx={{ display: 'inline-block', verticalAlign: 'middle' }}>
                <span role="img" aria-label="warning" style={{ fontSize: '16px', marginRight: '5px' }}>
                  ⚠️
                </span>
                CO2 Level reach its maximum level! Please check the scrubber
              </Typography>
            </Box>
          )}

          {Number(sseData.co2Low) === 1 && (
            <Box
              mb={2}
              sx={{
                textAlign: 'center',
                backgroundColor: '#fdecea',
                padding: '10px',
                borderRadius: '10px',
              }}
            >
              <Typography variant="body1" sx={{ display: 'inline-block', verticalAlign: 'middle' }}>
                <span role="img" aria-label="warning" style={{ fontSize: '16px', marginRight: '5px' }}>
                  ⚠️
                </span>
                Abnormal CO2 Level decrease is detected! Please check the chamber and the CO2 tube
              </Typography>
            </Box>
          )}

          {Number(sseData.humHigh) === 1 && (
            <Box
              mb={2}
              sx={{
                textAlign: 'center',
                backgroundColor: '#fdecea',
                padding: '10px',
                borderRadius: '10px',
              }}
            >
              <Typography variant="body1" sx={{ display: 'inline-block', verticalAlign: 'middle' }}>
                <span role="img" aria-label="warning" style={{ fontSize: '16px', marginRight: '5px' }}>
                  ⚠️
                </span>
                Abnormal Humidity Level increase is detected! Please check the chamber
              </Typography>
            </Box>
          )}

          {Number(sseData.humLow) === 1 && (
            <Box
              mb={2}
              sx={{
                textAlign: 'center',
                backgroundColor: '#fdecea',
                padding: '10px',
                borderRadius: '10px',
              }}
            >
              <Typography variant="body1" sx={{ display: 'inline-block', verticalAlign: 'middle' }}>
                <span role="img" aria-label="warning" style={{ fontSize: '16px', marginRight: '5px' }}>
                  ⚠️
                </span>
                Abnormal Humidity Level decrease is detected! Please check the chamber
              </Typography>
            </Box>
          )}

          {Number(sseData.DoorCondition) === 1 && (
            <Box
              mb={2}
              sx={{
                textAlign: 'center',
                backgroundColor: '#fdecea',
                padding: '10px',
                borderRadius: '10px',
              }}
            >
              <Typography variant="body1" sx={{ display: 'inline-block', verticalAlign: 'middle' }}>
                <span role="img" aria-label="warning" style={{ fontSize: '16px', marginRight: '5px' }}>
                  ⚠️
                </span>
                Chamber door is open!
              </Typography>
            </Box>
          )}

          <Box
            mb={2}
            sx={{
              textAlign: 'center',
              backgroundColor: '#eafcd4',
              padding: '10px',
              borderRadius: '10px',
            }}
          >
            <Typography variant="body1" sx={{ display: 'inline-block', verticalAlign: 'middle' }}>
              {sseData.gateway_temp ? (
                Number(level) === 2 ? (
                  <>
                    Gateway CPU Temperature: <strong>{sseData.gateway_temp} °С</strong>
                  </>
                ) : Number(level) === 1 ? (
                  <>Device online</>
                ) : null
              ) : (
                <>{showMessage ? 'Waiting for data...' : 'Device not online'}</>
              )}
            </Typography>
          </Box>

          {/* Baris pertama: Widget utama */}
          <Grid container spacing={3} mb={2}>
            <Grid item xs={12} sm={6} md={3}>
              <AppWidgetSummaryLiveData
                title="Temperature"
                total={JSON.stringify(sseData) === JSON.stringify({}) ? 0 : sseData.temperature}
                target={JSON.stringify(sseData) === JSON.stringify({}) ? 0 : sseData.SPtemp}
                color="primary"
                icon={'mdi:temperature-low'}
                prefix="°С"
                prefix2="°С"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <AppWidgetSummaryLiveData
                title="Humidity"
                total={JSON.stringify(sseData) === JSON.stringify({}) ? 0 : sseData.humidity}
                target={JSON.stringify(sseData) === JSON.stringify({}) ? 0 : sseData.SPhum}
                color="primary"
                icon={'material-symbols:humidity-percentage'}
                prefix="%"
                prefix2="%"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <AppWidgetSummaryLiveData
                title="Intensity"
                total={JSON.stringify(sseData) === JSON.stringify({}) ? 0 : sseData.intensity}
                target={JSON.stringify(sseData) === JSON.stringify({}) ? 0 : sseData.SPlight_intensity}
                color="primary"
                icon={'material-symbols:water-lux-rounded'}
                prefix="lux"
                prefix2="lux"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <PhotoCamera
                title="Sorry there is no camera data for this chamber, please check again later"
                total={JSON.stringify(sseData) === JSON.stringify({}) ? 0 : sseData.intensity}
                icon={'material-symbols:water-lux-rounded'}
                color="primary"
                prefix="lux"
                arraybot={cameraBot}
                arraytop={cameraTop}
                arraytopRight={cameraTopRight}
                arraybotRight={cameraBotRight}
                arrayuser={cameraUser}
              />
            </Grid>
          </Grid>

          {/* Baris kedua: Tambahan Widget untuk CO2 dan Light Spectrum */}
          <Grid container spacing={3} mb={2}>
            <Grid item xs={12} sm={6} md={6}>
              <AppWidgetSummaryLiveData
                title="CO2 Level"
                total={JSON.stringify(sseData) === JSON.stringify({}) ? 0 : sseData.co2level}
                target={JSON.stringify(sseData) === JSON.stringify({}) ? 0 : sseData.SPco2} // Pastikan properti target ada (misal: co2Target)
                color="primary"
                icon={'mdi:gas-cylinder'}
                prefix="ppm"
                prefix2 = "ppm"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <AppWidgetSummaryLiveData
                title="Light Spectrum"
                total={JSON.stringify(sseData) === JSON.stringify({}) ? 0 : sseData.SPlight_mode}
                target={JSON.stringify(sseData) === JSON.stringify({}) ? 0 : sseData.light_mode_colour} // Pastikan properti target ada (misal: lightSpectrumTarget)
                color="primary"
                icon={'mdi:lightbulb'}
                prefix="Mode"
                prefix2=""
              />
            </Grid>
          </Grid>

          <Box mt={4} mb={2}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <SpectrometerGraph
                  title="Spectrum Analysis"
                  spectrometerReference={spectrometerRef}
                  spectrometerPlot={spectrometerPlot}
                  spectrometerReferencePath={sseData.SpectrumReferencePath}
                  color="secondary"
                />
              </Grid>
            </Grid>
          </Box>

          <Box mt={4} mb={2}>
            {/* Main container Grid for left-right layout */}
            <Grid container spacing={2}>
              {/* Left side - Average Data */}
              <Grid item xs={12} md={6}>
                <Grid
                  container
                  direction="column"
                  justifyContent="space-around"
                  alignItems="center"
                  bgcolor="White"
                  borderRadius="10px"
                  padding="10px"
                  border="0.5px solid #ccc"
                  textAlign="center"
                  height="100%"
                >
                  <Grid item>
                    <Typography variant="h6" align="center" gutterBottom>
                      Average Data
                    </Typography>
                  </Grid>

                  {/* First Row: Temperature and Humidity */}
                  <Grid item container spacing={2} sx={{ flexDirection: { xs: 'column', md: 'row' }, mb: 2 }}>
                    <Grid item xs={6} md={6}>
                      <Box bgcolor="#F3E5F5" p={8} borderRadius={1}>
                        <Typography variant="h6" align="center" gutterBottom>
                          Temperature
                        </Typography>
                        <Box mb={1}>
                          <Typography variant="subtitle3" sx={{ color: 'rgba(0, 0, 0, 0.5)' }}>Day</Typography>
                          <Typography variant="subtitle1">{averageData[0]?.avg_temp_day ?? '-'} °C</Typography>
                        </Box>
                        <Box>
                          <Typography variant="subtitle3" sx={{ color: 'rgba(0, 0, 0, 0.5)' }}>Night</Typography>
                          <Typography variant="subtitle1">{averageData[0]?.avg_temp_night ?? '-'} °C</Typography>
                        </Box>
                      </Box>
                    </Grid>

                    <Grid item xs={6} md={6}>
                      <Box bgcolor="#F3E5F5" p={8} borderRadius={1}>
                        <Typography variant="h6" align="center" gutterBottom>
                          Humidity
                        </Typography>
                        <Box mb={1}>
                          <Typography variant="subtitle3" sx={{ color: 'rgba(0, 0, 0, 0.5)' }}>Day</Typography>
                          <Typography variant="subtitle1">{averageData[0]?.avg_hum_day ?? '-'} %</Typography>
                        </Box>
                        <Box>
                          <Typography variant="subtitle3" sx={{ color: 'rgba(0, 0, 0, 0.5)' }}>Night</Typography>
                          <Typography variant="subtitle1">{averageData[0]?.avg_hum_night ?? '-'} %</Typography>
                        </Box>
                      </Box>
                    </Grid>
                  </Grid>

                  {/* Second Row: Intensity and CO2 Level */}
                  <Grid item container spacing={2} sx={{ flexDirection: { xs: 'column', md: 'row' } }}>
                    <Grid item xs={6} md={6}>
                      <Box bgcolor="#F3E5F5" p={8} borderRadius={1}>
                        <Typography variant="h6" gutterBottom>
                          Intensity
                        </Typography>
                        <Box mb={1}>
                          <Typography variant="subtitle3" sx={{ color: 'rgba(0, 0, 0, 0.5)' }}>Day</Typography>
                          <Typography variant="subtitle1">{averageData[0]?.avg_light_day ?? '-'} lux</Typography>
                        </Box>
                        <Box>
                          <Typography variant="subtitle3" sx={{ color: 'rgba(0, 0, 0, 0.5)' }}>Night</Typography>
                          <Typography variant="subtitle1">{averageData[0]?.avg_light_night ?? '-'} lux</Typography>
                        </Box>
                      </Box>
                    </Grid>

                    <Grid item xs={6} md={6}>
                      <Box bgcolor="#F3E5F5" p={8} borderRadius={1}>
                        <Typography variant="h6" gutterBottom>
                          <strong>CO₂ Level</strong>
                        </Typography>
                        <Box mb={1}>
                          <Typography variant="subtitle3" sx={{ color: 'rgba(0, 0, 0, 0.5)' }}>Day</Typography>
                          <Typography variant="subtitle1">{averageData[0]?.avg_co2level_day ?? '-'} ppm</Typography>
                        </Box>
                        <Box>
                          <Typography variant="subtitle3" sx={{ color: 'rgba(0, 0, 0, 0.5)' }}>Night</Typography>
                          <Typography variant="subtitle1">{averageData[0]?.avg_co2level_night ?? '-'} ppm</Typography>
                        </Box>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              {/* Right side - Chart */}
              <Grid item xs={12} md={6}>
                {isLoading ? (
                  <Skeleton variant="rounded" height={550} />
                ) : (
                  <AppWebsiteVisits
                    title={formattedDateForDisplay}
                    chartLabels={chartData.time}
                    chartData={[
                      {
                        name: 'Temperature(°С)',
                        type: 'area',
                        fill: 'gradient',
                        data: chartData.temperature,
                      },
                      {
                        name: 'Humidity(%)',
                        type: 'area',
                        fill: 'gradient',
                        data: chartData.humidity,
                      },
                      {
                        name: 'Intensity(lx)',
                        type: 'area',
                        fill: 'gradient',
                        data: chartData.intensity,
                      },
                      {
                        name: 'Gateway Temperature(°С)',
                        type: 'area',
                        fill: 'gradient',
                        data: chartData.cpu_temp,
                      },
                      {
                        name: 'CO2 (ppm)',
                        type: 'area',
                        fill: 'gradient',
                        data: chartData.co2,
                      },
                    ]}
                    selectedDate={selectedDate}
                    formattedDate={formattedDate}
                    handleDateChange={handleDateChange}
                    averageData={averageData}
                  />
                )}
              </Grid>
            </Grid>
          </Box>
          
          <Box
            mt={2}
            mb={2}
            sx={{
              textAlign: 'center',
              padding: '10px',
              borderRadius: '10px',
              border: '0.5px solid #e6eaed',
              backgroundColor: 'white',
            }}
          >
            <Typography variant="h5" align="center" gutterBottom>
              Export Condition Data to Excel File
            </Typography>
            <div
              style={{
                display: 'flex',
                flexDirection: window.innerWidth <= 524 ? 'column' : 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Typography paragraph style={{ marginRight: '8px', marginTop: '20px' }}>
                  Start Date:
                </Typography>
                <DatePicker selected={selectedStartDate} onChange={handleStartDateChange} dateFormat="yyyy-MM-dd" />
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Typography paragraph style={{ marginRight: '8px', marginTop: '20px' }}>
                  End Date:
                </Typography>
                <DatePicker selected={selectedEndDate} onChange={handleEndDateChange} dateFormat="yyyy-MM-dd" />
              </div>
            </div>
            <div>
              <Button fullWidth size="large" type="submit" variant="contained" onClick={downloadExcel}>
                Download File
              </Button>
            </div>
            <div>
              <CardHeader
                subheader={`*This feature allows you to download Excel file of historical condition data for ${NameDevice} device. Data ranges from the entered start date to the specified end date.`}
                style={{ textAlign: 'left', marginBottom: '16px' }}
              />
            </div>
          </Box>

          <Box mt={4} mb={2}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <AppCurrentSubject
                  deviceId={IDDevice.toString()}
                  jwtToken={jwtToken}
                  color="secondary"
                />
              </Grid>
            </Grid>
          </Box>

          <Box mt={4} mb={2}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <AppDayNightSettings
                  deviceId={IDDevice.toString()}
                  jwtToken={jwtToken}
                  color="primary"
                />
              </Grid>
            </Grid>
          </Box>

        </Container>
      )}
    </>
  );
}
